import React from 'react';

import { IPohodnikRouterItem } from '.';

const HikingNew = React.lazy(() => import('@apps/Hiking/add/HikingNew'));
const HikingCommentsPage = React.lazy(() => import('@apps/Hiking/comments/HikingCommentsPage'));
const HikingConfirm = React.lazy(() => import('@apps/Hiking/confirm/HikingConfirm'));
const HikingDuty = React.lazy(() => import('@apps/Hiking/duty/HikingDuty'));
const HikingEquip = React.lazy(() => import('@apps/Hiking/equip/HikingEquip'));
const HikingEquipAdmin = React.lazy(() => import('@apps/Hiking/equip/HikingEquipAdmin'));
const HikingEquipShared = React.lazy(() => import('@apps/Hiking/equip/HikingEquipShared'));
const HikingEquipMy = React.lazy(() => import('@apps/Hiking/equip/HikingMy'));
const HikingShopping = React.lazy(() => import('@apps/Hiking/equip/HikingShopping'));
const HikingFinancesPage = React.lazy(() => import('@apps/Hiking/finance/HikingFinancesPage'));
const FirstAidKitPage = React.lazy(() => import('@apps/Hiking/first_aid_kit/FirstAidKitPage'));
const HikingRouteInfoPage = React.lazy(
  () => import('@apps/Hiking/hiking_route/HikingRouteInfoPage'),
);
const HikingTimezones = React.lazy(() => import('@apps/Hiking/HikingTimezones'));
const HikingListsPage = React.lazy(() => import('@apps/Hiking/list/HikingListsPage'));
const HikingMenu = React.lazy(() => import('@apps/Hiking/menu/components/HikingMenu'));
const HikingMenuMatrixPage = React.lazy(
  () => import('@apps/Hiking/menu/components/HikingMenu/components/HikingMenuMatrixPage'),
);
const HikingMenuDishes = React.lazy(() => import('@apps/Hiking/menu/components/HikingMenuDishes'));
const HikingMenuFoodActRecipesCategories = React.lazy(
  () => import('@apps/Hiking/menu/components/HikingMenuFoodActRecipesCategories'),
);
const HikingMenuPrint = React.lazy(() => import('@apps/Hiking/menu/components/HikingMenuPrint'));
const HikingMenuPrintStickers = React.lazy(
  () => import('@apps/Hiking/menu/components/HikingMenuPrintStickers'),
);
const HikingNotesPage = React.lazy(() => import('@apps/Hiking/notes/HikingNotesPage'));
const HikingObstacleNotes = React.lazy(
  () => import('@apps/Hiking/obstacleNotes/HikingObstacleNotes'),
);
const HikingObstacleEditPage = React.lazy(
  () => import('@apps/Hiking/obstacles/HikingObstacleEditPage'),
);
const HikingObstaclesPage = React.lazy(() => import('@apps/Hiking/obstacles/HikingObstaclesPage'));
const HikingOneHikingObstaclePage = React.lazy(
  () => import('@apps/Hiking/obstacles/HikingOneHikingObstaclePage'),
);
const ObstacleInHikingPage = React.lazy(
  () => import('@apps/Hiking/obstacles/ObstacleInHikingPage'),
);
const HikingOne = React.lazy(() => import('@apps/Hiking/one/HikingOne'));
const AllPositions = React.lazy(() => import('@apps/Hiking/positions/AllPositions'));
const HikingPrint = React.lazy(() => import('@apps/Hiking/print/HikingPrint'));
const HikingObservationsPage = React.lazy(() => import('@apps/Hiking/HikingObservations'));
const HikingRepairKitPage = React.lazy(() => import('@apps/Hiking/repair_kit/HikingRepairKitPage'));
const HikingRepairKitPrintPage = React.lazy(
  () => import('@apps/Hiking/repair_kit/HikingRepairKitPrintPage'),
);
const HikingResults = React.lazy(() => import('@apps/Hiking/results/HikingResults'));
const HikingSchedulePage = React.lazy(() => import('@apps/Hiking/schedule/HikingSchedulePage'));
const HikingTracks = React.lazy(() => import('@apps/Hiking/tracks/HikingTracks'));
const HikingTrackOne = React.lazy(() => import('@apps/Hiking/tracks/HikingTracksOne'));
const HikingWorkouts = React.lazy(() => import('@apps/Hiking/tracks/workouts/HikingWorkouts'));

const HikingArticlesPage = React.lazy(() => import('@apps/Hiking/articles/HikingArticlesPage'));
const HikingArticleOnePage = React.lazy(() => import('@apps/Hiking/articles/HikingArticleOnePage'));
const HikingJointlyEquipment = React.lazy(() => import('@apps/Hiking/HikingJointlyEquipment'));
const HikingTransfers = React.lazy(() => import('@apps/Hiking/HikingTransfers'));
const HikingArticlesPrintPage = React.lazy(
  () => import('@apps/Hiking/articles/HikingArticlesPrintPage'),
);

const HikingFinancesOneReceiptPage = React.lazy(
  () => import('@apps/Hiking/finance/HikingFinancesOneReceiptPage'),
);

const HikingEditPage = React.lazy(() => import('@apps/Hiking/edit/HikingEditPage'));

const hikingRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/hiking/:id/hiking_route_info/:id_route',
    component: ({
      match: {
        params: { id, id_route },
      },
    }) => <HikingRouteInfoPage id_hiking={+id} id_route={+id_route} />,
    protected: true,
    title: 'Информация о маршруте похода',
  },
  {
    path: '/hiking/:id/my',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingEquipMy id_hiking={+id} />,
    protected: true,
    title: 'Информация о походе для участника',
  },
  {
    path: '/hiking/:id/edit',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingEditPage id_hiking={+id} />,
    protected: true,
    title: 'Редактирование похода',
  },
  {
    path: '/hiking/:id/equip/admin',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingEquipAdmin id_hiking={+id} />,
    protected: true,
    title: 'Редактирование группового снаряжения',
  },
  {
    path: '/hiking/:id/equip/shared',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingEquipShared id_hiking={+id} />,
    protected: true,
    title: 'Список рюкзаков участников похода в которые можно заглянуть',
  },
  {
    path: '/hiking/:id/equip/:id_set',
    component: ({
      match: {
        params: { id, id_set },
      },
    }) => <HikingEquip id_hiking={+id} id_set={+id_set} />,
    protected: true,
    title: 'Просмотр снаряжения участника похода',
  },

  {
    path: '/hiking/:id/obstacles/:id_obstacle/:id_hiking_obstacle/edit',
    component: ({
      match: {
        params: { id, id_hiking_obstacle },
      },
    }) => <HikingObstacleEditPage id_hiking={+id} id_hiking_obstacle={+id_hiking_obstacle} />,
    protected: true,
    title: 'Редактирование локального препятствия или POI похода',
  },

  {
    path: '/hiking/:id/obstacles/:id_obstacle/:id_hiking_obstacle',
    component: ({
      match: {
        params: { id, id_hiking_obstacle },
      },
      location: { search },
    }) => (
      <HikingOneHikingObstaclePage
        id_hiking={+id}
        id_hiking_obstacle={+id_hiking_obstacle}
        search={search}
      />
    ),
    protected: true,
    title: 'Локальное препятствие или POI похода',
  },

  {
    path: '/hiking/:id/obstacles/:id_obstacle',
    component: ({
      match: {
        params: { id, id_obstacle },
      },
      location: { search },
    }) => <ObstacleInHikingPage id_hiking={+id} id_obstacle={+id_obstacle} search={search} />,
    protected: true,
    title: 'Локальное препятствие или POI в походе',
  },

  {
    path: '/hiking/:id/obstacles',
    component: ({
      match: {
        params: { id },
      },
      location: { search },
    }) => <HikingObstaclesPage id_hiking={+id} search={search} />,
    protected: true,
    title: 'Список локальных препятствий и POI похода',
  },

  {
    path: '/hiking/:id/notes',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingNotesPage id_hiking={+id} />,
    protected: false,
    title: 'Заметки похода',
  },
  {
    path: '/hiking/:id/obstacle_notes',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingObstacleNotes id_hiking={+id} />,
    protected: true,
    title: 'Перевальные записки похода',
  },
  {
    path: '/hiking/:id/equip',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingEquip id_hiking={+id} />,
    protected: true,
    title: 'Собрать рюкзак для похода',
  },
  {
    path: '/hiking/:id/duty',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingDuty id_hiking={+id} />,
    protected: true,
    title: 'Дежурства в походе',
  },
  {
    path: '/hiking/:id/timezones',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingTimezones id_hiking={+id} />,
    protected: true,
    title: 'Часовые пояса похода',
  },
  {
    path: '/hiking/:id/shopping',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingShopping id_hiking={+id} />,
    protected: true,
    title: 'Список покупок для похода',
  },
  {
    path: '/hiking/:id/fak',
    component: ({
      match: {
        params: { id },
      },
    }) => <FirstAidKitPage id_hiking={+id} />,
    protected: true,
    title: 'Аптечка похода',
  },
  {
    path: '/hiking/:id/repair-kit/print',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingRepairKitPrintPage id_hiking={+id} />,
    protected: true,
    title: 'Ремнабор похода. Печать',
  },

  {
    path: '/hiking/:id/repair-kit',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingRepairKitPage id_hiking={+id} />,
    protected: true,
    title: 'Ремнабор похода',
  },

  {
    path: '/hiking/:id/tracks/:id_hiking_track',
    component: ({
      match: {
        params: { id, id_hiking_track },
      },
    }) => <HikingTrackOne id_hiking={+id} id_hiking_track={+id_hiking_track} />,
    protected: true,
    title: 'Просмотр трека похода',
  },
  {
    path: '/hiking/:id/tracks',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingTracks id_hiking={+id} />,
    protected: true,
    title: 'Список треков похода',
  },
  {
    path: '/hiking/:id/workouts',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingWorkouts id_hiking={+id} />,
    protected: true,
    title: 'Тренировки похода',
  },
  {
    path: '/hiking/:id_hiking/finances/:id_receipt',
    component: ({
      match: {
        params: { id_hiking, id_receipt },
      },
    }) => <HikingFinancesOneReceiptPage id_hiking={+id_hiking} id_receipt={+id_receipt} />,
    protected: true,
    title: 'Просмотр чека',
  },
  {
    path: '/hiking/:id/finances',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingFinancesPage id_hiking={+id} />,
    protected: true,
    title: 'Финансы похода',
  },
  {
    path: '/hiking/:id/finance',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingFinancesPage id_hiking={+id} />,
    protected: true,
  },
  {
    path: '/hiking/:id/comments',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingCommentsPage id_hiking={+id} />,
    protected: true,
    title: 'Комментарии',
  },
  {
    path: '/hiking/:id/menu/print1',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingMenuPrint id_hiking={+id} />,
    protected: true,
    title: 'Печать меню похода',
  },
  {
    path: '/hiking/:id/menu/matrix',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingMenuMatrixPage id_hiking={+id} />,
    protected: true,
    title: 'Матрица меню похода',
  },
  {
    path: '/hiking/:id/menu/stickers',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingMenuPrintStickers id_hiking={+id} />,
    protected: true,
    title: 'Печать наклеек для меню похода',
  },
  {
    path: '/hiking/:id/menu/dishes',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingMenuDishes id_hiking={+id} />,
    protected: true,
    title: 'Блюда для меню похода',
  },
  {
    path: '/hiking/:id/menu/acts',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingMenuFoodActRecipesCategories id_hiking={+id} />,
    protected: true,
    title: 'Приемы пищи похода',
  },
  {
    path: '/hiking/:id/menu2',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingMenu id_hiking={+id} />,
    protected: true,
  },
  {
    path: '/hiking/:id/menu',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingMenu id_hiking={+id} />,
    protected: true,
    title: 'Меню похода',
  },
  {
    path: '/hiking/:id/results',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingResults id_hiking={+id} />,
    protected: true,
    title: 'Итоги похода',
  },
  {
    path: '/hiking/:id/schedule',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingSchedulePage id_hiking={+id} />,
    title: 'Расписание похода (план)',
  },
  {
    path: '/hiking/:id/confirm',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingConfirm id={+id} />,
    protected: true,
    title: 'Подтверждение участия в походе',
  },
  {
    path: '/hiking/:id/print',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingPrint id_hiking={+id} />,
    protected: true,
    title: 'Печать похода',
  },
  {
    path: '/hiking/:id/observations',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingObservationsPage id_hiking={+id} />,
    protected: true,
    title: 'Наблюдения похода (inaturalist)',
  },
  {
    path: '/hiking/:id/articles/:id_hiking_article',
    component: ({
      match: {
        params: { id, id_hiking_article },
      },
    }) => <HikingArticleOnePage id_hiking={+id} id_hiking_article={+id_hiking_article} />,
    protected: true,
    title: 'Статья похода',
  },
  {
    path: '/hiking/:id/articles/print',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingArticlesPrintPage id_hiking={+id} />,
    protected: true,
    title: 'Печать статей похода',
  },

  {
    path: '/hiking/:id/articles',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingArticlesPage id_hiking={+id} />,
    protected: true,
    title: 'Статьи похода',
  },
  {
    path: '/hiking/:id/tents',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingJointlyEquipment id_hiking={+id} type="tent" />,
    protected: true,
    title: 'Палатки похода',
  },
  {
    path: '/hiking/:id/watercraft',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingJointlyEquipment id_hiking={+id} type="watercraft" />,
    protected: true,
    title: 'Плавсредства похода',
  },
  {
    path: '/hiking/:id/transfers',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingTransfers id_hiking={+id} />,
    protected: true,
    title: 'Трансферы похода',
  },
  {
    path: '/hiking/new',
    component: () => <HikingNew />,
    protected: false,
    title: 'Создание похода',
  },
  {
    path: '/hiking/positions',
    component: () => <AllPositions />,
    protected: false,
    title: 'Список должностей похода',
  },

  {
    path: '/hiking/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <HikingOne id_hiking={+id} />,
    protected: false,
    title: 'Страница похода',
  },
  {
    path: '/hiking',
    component: () => <HikingListsPage />,
    protected: true,
    title: 'Список походов',
  },
];

export default hikingRoutes;
